import { render, staticRenderFns } from "./TableImg.vue?vue&type=template&id=2a1e0b98&scoped=true&"
import script from "./TableImg.vue?vue&type=script&lang=js&"
export * from "./TableImg.vue?vue&type=script&lang=js&"
import style0 from "./TableImg.vue?vue&type=style&index=0&id=2a1e0b98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e0b98",
  null
  
)

export default component.exports